<template>
  <div class="service-container" v-show="serviceLink" @click="openService">
    <img src="../../assets/image/download/service-img.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "FloatService",
  computed: {
    serviceLink() {
      const [link] = this.$store.state.customerService;
      return link || "";
    },
  },
  methods: {
    openService() {
      window.open(this.serviceLink, "_blank");
    },
  },
};
</script>

<style lang="scss">
.service-container {
  position: fixed;
  top: 40%;
  right: 0;
  z-index: 10;
  cursor: pointer;
  animation: float 6s ease-in-out infinite;
  img {
    display: block;
  }
}
@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-30px);
  }
  100% {
    transform: translatey(0px);
  }
}
</style>
